import * as types from '../mutation-types';
import api from '@/store/utils/api';
import router from '@/router';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const vueCookies = new Vue();
// We use local storage to remember if we successfully authenticated previously
const authCookieName = 'tecobiToken';
const hostParts = window.location.hostname.split('.').reverse();
const rootDomain = `.${hostParts[1]}.${hostParts[0]}`;

function isAuthenticated() {
    return !!vueCookies.$cookies.get(authCookieName);
}

// You can use it as state property
const state = {
    isAuthenticated: isAuthenticated(),
    token: vueCookies.$cookies.get(authCookieName),
    user: null,
};

// You can use it as a state getter function (probably the best solution)
const getters = {
    isAuthenticated: state => state.isAuthenticated,
    token: state => state.token,
    user: state => state.user,
};

const actions = {
    login({ commit }, payload) {
        return api.post('/auth/login/', payload).then(response => {
            let myDate = new Date();
            myDate.setMonth(myDate.getMonth() + 12);
            vueCookies.$cookies.set(authCookieName,response.key, myDate,  '', rootDomain);
            commit(types.TOKEN, {
                token: response.key,
            });
            commit(types.IS_AUTHENTICATED, {
                isAuthenticated: true,
            });
            return response;
        });
    },
    fetchUser({ commit }) {
        return api.get('/auth/user/').then(response => {
            commit(types.UPDATE_USER, response);
            return response;
        });
    },
    logout({ commit }, payload) {
        const promise = new Promise(function(resolve, reject) {
            setTimeout(function() {
                vueCookies.$cookies.remove(authCookieName, '', rootDomain);
                console.log(vueCookies.$cookies.isKey(authCookieName) )
                resolve('logged out');
            }, 1);
        });
        return promise.then(response => {
            commit(types.IS_AUTHENTICATED, {
                isAuthenticated: false,
            });
            router.replace('/login');
            return response;
        });
    },
};

// Mutation for when you use it as state property
const mutations = {
    [types.IS_AUTHENTICATED](state, payload) {
        state.isAuthenticated = payload.isAuthenticated;
    },
    [types.UPDATE_USER](state, payload) {
        state.user = payload;
    },
    [types.TOKEN](state, payload) {
        state.token = payload.token;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
